import { render, staticRenderFns } from "./GeneralizeAgentClientMsg.vue?vue&type=template&id=bd956ce2&"
import script from "./GeneralizeAgentClientMsg.vue?vue&type=script&lang=js&"
export * from "./GeneralizeAgentClientMsg.vue?vue&type=script&lang=js&"
import style0 from "./GeneralizeAgentClientMsg.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports